import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {User} from '../models/User';
import {Observable} from 'rxjs';
import {Table} from '../models/Table';
import {Venue} from '../models/Venue';

import {environment} from '../../environments/environment';
import {UberCancelReason} from '../components/manager-components/manual-acceptance-order/manual-acceptance-order';

@Injectable({
	providedIn: 'root'
})
export class ApiService {
	constructor(private http: HttpClient) {}

	BASE_URL = environment.apiUrl;
	VERSION = '/v1';
	AUTH_URL = `${this.VERSION}/auth`;
	GENERAL_URL = `${this.VERSION}/general`;
	MONITORING_URL = `${this.VERSION}/monitoring`;

	login(data: {email: String; password: String}): Observable<User> {
		return this.http.post<User>(`${this.BASE_URL}${this.AUTH_URL}/login`, data);
	}

	refresh(refreshToken: string) {
		return this.http.post<User>(`${this.BASE_URL}${this.AUTH_URL}/refresh`, {
			refreshToken
		});
	}
	// get venue by customer group  ->
	getTablesVenue(id: string): Observable<Table[]> {
		return this.http.get<Table[]>(
			`${this.BASE_URL}${this.GENERAL_URL}/venue/${id}/tables`
		);
	}
	getVenue(id: string) {
		return this.http.get<Venue>(
			`${this.BASE_URL}${this.GENERAL_URL}/venue/${id}`
		);
	}

	updateVenue(venue: Venue) {
		return this.http.patch<Venue>(
			`${this.BASE_URL}${this.GENERAL_URL}/venue/${venue._id}`,
			{
				...venue
			}
		);
	}

	updateVenueDelivery(venue: Venue) {
		return this.http.patch<Venue>(
			`${this.BASE_URL}${this.GENERAL_URL}/venue/${venue._id}`,
			{
				...venue
			}
		);
	}

	changeOrderOffsetWolt(
		venueId: string,
		value: {
			deliveryTime: number;
			preparationTime: number;
		}
	) {
		return this.http.patch(
			`${this.BASE_URL}${this.GENERAL_URL}/venue/${venueId}/external-order-providers/wolt/offsets`,
			value
		);
	}
	changeOrderOffsetUber(
		venueId: string,
		value: {
			preparationTime: number;
		}
	) {
		return this.http.patch(
			`${this.BASE_URL}${this.GENERAL_URL}/venue/${venueId}/external-order-providers/uber-eats/offsets`,
			value
		);
	}
	updateUberDirectDeliveryStatus(venueId: string, status: boolean) {
		return this.http.patch<Venue>(
			`${this.BASE_URL}${this.GENERAL_URL}/venue/${venueId}/delivery-providers/uber_direct/status`,
			{
				status: status
			}
		);
	}
	activateDeactivateActivateUber(
		venueId: string,
		value: boolean,
		snoozed: string
	) {
		let obj = {
			status: value
		} as any;
		if (snoozed) {
			obj = {...obj, snoozed: snoozed};
		}
		return this.http.patch(
			`${this.BASE_URL}${this.GENERAL_URL}/venue/${venueId}/external-order-providers/uber-eats`,
			obj,
			{observe: 'response', responseType: 'text'}
		);
	}
	activateDeactivateActivateWolt(
		venueId: string,
		value: boolean,
		snoozed: string
	) {
		let obj = {
			status: value
		} as any;
		if (snoozed) {
			obj = {...obj, snoozed: snoozed};
		}
		return this.http.patch(
			`${this.BASE_URL}${this.GENERAL_URL}/venue/${venueId}/external-order-providers/wolt`,
			obj,
			{observe: 'response', responseType: 'text'}
		);
	}

	updateOffsetsVenue(
		venueId: string,
		data: {
			preparationTime: number;
		}
	) {
		return this.http.patch(
			`${this.BASE_URL}${this.GENERAL_URL}/venue/${venueId}/offsets`,
			data
		);
	}

	// ===== WOLT MANUAL ACCEPTING =====

	acceptWoltManually(
		venueId: string,
		externalOrderId: string,
		payload: {
			preparationTime: number;
			deliveryTime?: number;
		}
	) {
		return this.http.patch(
			`${this.BASE_URL}${this.VERSION}/wolt/orders/venues/${venueId}/orders/${externalOrderId}/accept`,
			payload
		);
	}

	rejectWoltManually(
		venueId: string,
		externalOrderId: string,
		payload: {
			reason: string;
		}
	) {
		return this.http.patch(
			`${this.BASE_URL}${this.VERSION}/wolt/orders/venues/${venueId}/orders/${externalOrderId}/reject`,
			payload,
			{responseType: 'text'}
		);
	}

	// ===== UBER MANUAL ACCEPTING =====

	acceptUberManually(
		venueId: string,
		externalOrderId: string,
		payload: {
			preparationTime: number;
		}
	) {
		return this.http.patch(
			`${this.BASE_URL}${this.VERSION}/uber/eats/orders/venues/${venueId}/orders/${externalOrderId}/accept`,
			payload
		);
	}

	rejectUberManually(
		venueId: string,
		externalOrderId: string,
		payload: {
			info: string;
			type: UberCancelReason;
		}
	) {
		return this.http.patch(
			`${this.BASE_URL}${this.VERSION}/uber/eats/orders/venues/${venueId}/orders/${externalOrderId}/cancel`,
			payload,
			{responseType: 'text'}
		);
	}
}
